

import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form, Table, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./membercss/Campaignments.css";
import Avatars from './Avatars';
import useTranslations from "../transalation/TranslationUtils";
import { useSelector } from "react-redux";
import { Box, CardActions, CardContent, Divider, Rating, TextField, Typography } from "@mui/material";
import { getCampaignEngageList, getSurvey, setSimpleData } from "app/redux/slices/rdxMemberSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
function Campaignengagement() {
    const dispatch = useDispatch();
    const memberEditData = useSelector((state) => state.rdxMember?.memberEditData || {});
    const engageInfos = useSelector((state) => state.rdxMember?.engageInfos || {});
    const engageCounts = useSelector((state) => state.rdxMember?.engageCounts || {});
    const editSurvey = useSelector((state) => state.rdxMember?.editSurvey || {});
    const [activeTab, setActiveTab] = useState("In-Progress");
    const [showRateModal, setShowRateModal] = useState(false);
    const { campaignEngagement,
        campaignDetails,
        inProgress,
        completed,
        applicationStatus,
        campaignName,
        type,
        code,
        startDate,
        endDate,
        every,
        totalClasses,
        attendance,
        absence,
        reason, campaignname, func_t, pushstatus,
        close, mUpdate, mSend, mQuestion, i18nObj,
        mSuggestion, method, showErrMsg } = useTranslations();

    useEffect(() => {
        dispatch(getCampaignEngageList({ "account_id": memberEditData.account_id }));
    }, []);

    function formatDate(input, format = "date") {
        let date;

        if (!input) {
            return "";
        } else if (typeof input === "string") {
            date = new Date(input);
        } else if (typeof input === "number") {
            date = new Date(input);
        } else if (Array.isArray(input) && input.length === 1 && typeof input[0] === "number") {
            date = new Date(input[0]);
        } else {
            return "Invalid";
        }

        // Ensure the Date object is valid
        if (isNaN(date.getTime())) {
            return "Invalid";
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        if (format === "date") {
            return `${year}-${month}-${day}`;
        } else if (format === "datetime") {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        } else {
            return "Invalid";
        }
    }

    const getMethod = (method) => {
        switch (method) {
            case 1:
                return "first-come-first-served";
            case 2:
                return "Lottery-drawing";
            default:
                return "";
        }
    };

    const getStatusDescription = (status) => {
        switch (status) {
            case 1:
                return "approve";
            case 2:
                return "pre-approve";
            case 3:
                return "waitlisted";
            case 4:
                return "Withdrawn";
            case 5:
                return "cancelled";
            default:
                return "Unknown";
        }
    };

    const onCompletedItemClick = (item) => {
        let sendData = {
            "account_id": item.account_id,
            "campaign_id": item.campaign_id
        }
        dispatch(getSurvey(sendData, (isSuccess, data) => {
            if (!isSuccess) {
                alert(showErrMsg(data));
            } else {
                setShowRateModal(true);
            }
        }))
    }

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <Container fluid>
            <Row>
                <Col md={12}>
                    <Card className="mt-0 border-0" style={{ position: "relative" }}>
                        <Card.Body>
                            <Avatars initAvatar={memberEditData["account_avatar"]} />
                            <br />
                            <Card className="m-3">
                                <Card.Body>
                                    <Row>
                                        <h5 className="basicinfo">{campaignDetails()}</h5>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xs={12} md={7} className="d-flex justify-content-between">
                                            {["In-Progress", "Completed", "Application Status"].map((tab, index) => (
                                                <div
                                                    key={index}
                                                    className={`tab-link ${activeTab === tab ? "active" : ""}`}
                                                    onClick={() => handleTabClick(tab)}
                                                    style={{
                                                        cursor: "pointer",
                                                        fontWeight: activeTab === tab ? "bold" : "normal",
                                                        color: activeTab === tab ? "blue" : "black",
                                                        paddingBottom: "5px",
                                                        borderBottom: activeTab === tab ? "2px solid blue" : "none",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {'In-Progress' == tab && (
                                                        <span>{inProgress()}</span>
                                                    )}
                                                    {'Completed' == tab && (
                                                        <span>{completed()}</span>
                                                    )}
                                                    {'Application Status' == tab && (
                                                        <span>{applicationStatus()}</span>
                                                    )}
                                                    <br />
                                                    <small style={{ color: "#6c757d", fontSize: "12px" }}>
                                                        {engageCounts[tab]} {engageCounts[tab] === 1 ? "" : ""}
                                                    </small>
                                                </div>
                                            ))}
                                        </Col>
                                    </Row>

                                    {/* Conditional Rendering for Tables */}
                                    {activeTab === "In-Progress" && (
                                        <Row className="in-proogress">
                                            <div className="table-responsive">
                                                <Table striped hover className="mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th className="custom-th">{campaignName()}</th>
                                                            <th className="custom-th">{type()}</th>
                                                            <th className="custom-th">{code()}</th>
                                                            <th className="custom-th">{startDate()}</th>
                                                            <th className="custom-th">{endDate()}</th>
                                                            <th className="custom-th">{totalClasses()}</th>
                                                            <th className="custom-th">{attendance()}</th>
                                                            <th className="custom-th">{absence()}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {engageInfos.processing?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="custom-td">{i18nObj(item.campaign_name)}</td>
                                                                <td className="custom-td">{i18nObj(item.campaign_type)}</td>
                                                                <td className="custom-td">{item.campaign_code}</td>
                                                                <td className="custom-td"> {formatDate(item.campaign_start_date, "date")}</td>
                                                                <td className="custom-td">{formatDate(item.campaign_end_date, "date")}</td>
                                                                <td className="custom-td">{item.total_courses}</td>
                                                                <td className="custom-td">{item.attendance_rate}%</td>
                                                                <td className="custom-td">{item.course_absence}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Row>
                                    )}

                                    {activeTab === "Completed" && (
                                        <Row className="complete">
                                            <div className="table-responsive">
                                                <Table striped hover className="mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th className="custom-th">{campaignName()}</th>
                                                            <th className="custom-th">{type()}</th>
                                                            <th className="custom-th">{code()}</th>
                                                            <th className="custom-th">{startDate()}</th>
                                                            <th className="custom-th">{endDate()}</th>
                                                            <th className="custom-th">{func_t()}</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {engageInfos.completed?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="custom-td">{i18nObj(item.campaign_name)}</td>
                                                                <td className="custom-td">{i18nObj(item.campaign_type)}</td>
                                                                <td className="custom-td">{item.campaign_code}</td>
                                                                <td className="custom-td"> {formatDate(item.campaign_start_date, "date")}</td>
                                                                <td className="custom-td">{formatDate(item.campaign_end_date, "date")}</td>
                                                                <td className="custom-td">
                                                                    <Button variant="primary" className="me-2 feedback"
                                                                        style={{ "whiteSpace": "nowrap" }}
                                                                        onClick={(e) => onCompletedItemClick(item)}>
                                                                        View Feedback
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Row>
                                    )}

                                    {activeTab === "Application Status" && (
                                        <Row className="application-status">
                                            <div className="table-responsive">
                                                <Table striped hover className="mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th className="custom-th">{campaignName()}</th>
                                                            <th className="custom-th">{method()}</th>
                                                            <th className="custom-th">{type()}</th>
                                                            <th className="custom-th">{code()}</th>
                                                            <th className="custom-th">{startDate()}</th>
                                                            <th className="custom-th">{endDate()}</th>
                                                            <th className="custom-th">{pushstatus()}</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {engageInfos.applied?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="custom-td">{i18nObj(item.campaign_name)}</td>
                                                                <td className="custom-td">{getMethod(item.campaign_enrolment_method)}</td>
                                                                <td className="custom-td">{i18nObj(item.campaign_type)}</td>
                                                                <td className="custom-td">{item.campaign_code}</td>
                                                                <td className="custom-td"> {formatDate(item.campaign_start_date, "date")}</td>
                                                                <td className="custom-td">{formatDate(item.campaign_end_date, "date")}</td>
                                                                <td className="custom-td">{getStatusDescription(item.enroll_status)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Row>
                                    )}
                                </Card.Body>
                            </Card>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Modal
                show={showRateModal}
                centered
                className="custom-modal-width">
                <Modal.Body>
                    <Box>
                        {editSurvey.map((item, index) => (
                            <React.Fragment key={index}>
                                {"text" != item.survey_id && (
                                    <React.Fragment>
                                        <Card>
                                            <CardContent>
                                                <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>{mQuestion()}</Typography>
                                                <Typography variant="h5" component="div">{i18nObj(item.survey_content)}</Typography>
                                            </CardContent>
                                            <div style={{ "height": "1px", "margin": "0px 13px", "background": "#cccccc" }}></div>
                                            <CardActions>
                                                <Rating
                                                    readOnly
                                                    className="ms-1"
                                                    name={"simple-controlled" + index}
                                                    value={item.survey_score}
                                                />
                                            </CardActions>
                                        </Card>
                                        <br />
                                    </React.Fragment>
                                )}
                                {"text" == item.survey_id && (
                                    <TextField
                                        label={mSuggestion()}
                                        value={item.survey_text}
                                        multiline
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </Box>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => { setShowRateModal(false); }}
                        className="me-2"
                    >
                        {close()}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default Campaignengagement;
